import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import '../../components/Css/style.css';
import {HomeContainer,ContentContainer,InfoBox,SubInfo} from "../../utils/style";
import { useTranslation } from "react-i18next";

const Success = () => {

  const navigate = useNavigate();
  const { t } = useTranslation("global");

  return (

     <HomeContainer>
        <ContentContainer>
          <InfoBox>
            <SubInfo>
                 <div className='pt-5'>
                  <div className="row align-items-center">
                      <img src="/images/logo.png" alt="Kidz Mania" className="img"/>  
                  </div>
                </div>  
              <h2>{t("portalText.Unsub Msg")}</h2>
              {/* <PrimaryButton
                onClick={()=>navigate("/login")}
                type="primary"
              >
                Click For Subscribe
              </PrimaryButton>
              */}
              </SubInfo>
            </InfoBox>
          </ContentContainer>
     </HomeContainer>
  )
}


export default Success;


